"use client";
import { Container } from "@/components/layout/Container";
import s from "./SectionPromo.module.scss";
import st from "@/styles/modules/typography.module.scss";
import { SearchForm } from "@/components/forms/SearchForm";
import { Heading } from "@/components/UI/typography/Heading";
import cn from "classnames";
import { Reviews } from "@/components/shared/Reviews";

export const SectionPromo = () => {
  return (
    <section className={s.sectionPromo}>
      <Container className={s.container}>
        <Heading level={1} className={s.heading}>
          Database of <span>free essays</span> <br />
          to fuel your creativity
        </Heading>
        <ul className={cn(st.bigList, st.bigListHorizontal, s.list)}>
          <li>100% free essays</li>
          <li>Thousands of topics</li>
          <li>Regularly added samples</li>
        </ul>
        <SearchForm />
        <Reviews className={s.reviews} />
      </Container>
    </section>
  );
};
